import PropTypes from 'prop-types';

const SideNavigationGroup = ({ children }) => {
  return (
    <div className="side-navigation-group border-gray-2 border-b mb-6 pb-6">
      {children}
    </div>
  );
};

SideNavigationGroup.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SideNavigationGroup;
